import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import HeroBasic, {heroBasicSizes, heroBasicTitleSizes} from '@adv-mt/mt-hero-basic'
import Layout from '@adv-mt/mt-layout-basic'
import PanelAddVehicles from '@adv-mt/mt-panel-add-vehicles'
import SectionBasic, {sectionBasicMargins} from '@adv-mt/mt-section-basic'

import LinkFactory from '../../../components/LinkFactory/index.js'

const BASE_CLASS = 'mt-TechnicalDetailsComparator'

const Skeleton = () => {
  const {domain, i18n} = useContext(Context)
  useMount(() => window.scrollTo(0, 0))

  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const HeroBasicProps = {
    title: {
      title: i18n.t('TECHNICAL_DETAILS_COMPARATOR_HERO_TITLE'),
      description: i18n.t('TECHNICAL_DETAILS_COMPARATOR_HERO_SUBTITLE'),
      size: heroBasicTitleSizes.s
    },
    imageSrc: `${URL_STATICS_IMAGES}technical-details-comparator-hero.jpg`,
    size: heroBasicSizes.s
  }

  return (
    <Layout.Basic linkFactory={LinkFactory} isPaddingless isMarginless>
      <SectionBasic margin={sectionBasicMargins.xxl}>
        <HeroBasic {...HeroBasicProps} />
      </SectionBasic>
      <SectionBasic margin={sectionBasicMargins.xxl}>
        <div className={`${BASE_CLASS}-panelAddVehiclesWrapper`}>
          <PanelAddVehicles />
        </div>
      </SectionBasic>
      <div className="mt-TechnicalDetailsComparatorLoading"></div>
    </Layout.Basic>
  )
}

export default Skeleton
